// extracted by mini-css-extract-plugin
export default {"breakpointDesktop":"1024px","breakpointDesktopMedium":"1280px","breakpointDesktopLarge":"1450px","breakpointTablet":"768px","breakpointPhone":"640px"};